import { render, staticRenderFns } from "./VehicleInspectionList.vue?vue&type=template&id=54302b7c&scoped=true"
import script from "./VehicleInspectionList.vue?vue&type=script&lang=js"
export * from "./VehicleInspectionList.vue?vue&type=script&lang=js"
import style0 from "./VehicleInspectionList.vue?vue&type=style&index=0&id=54302b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54302b7c",
  null
  
)

export default component.exports